<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vnr5cq/tc-custom/9781446350935.jpg?1737060338355" alt="This image is the cover for the book Jelly Roll Inspirations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jelly Roll Inspirations
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Grab a jelly roll bundle and prepare to make a beautiful quilt with one of the twelve designs in this collection compiled by the authors of <i>Jelly Roll Quilts</i>.</b><br/><br/> The Jelly Roll Challenge was an international competition to find the best and most creative use of one Jelly Roll. Gathered here are the twelve fabulous winning entries with step-by-step instructions on how to make them.<br/><br/> · A dozen Jelly Roll quilt designs<br/> · Get inspired by these designers and their unique take on the Jelly Roll<br/> · Each quilt has a variation made by bestselling authors Pam and Nicky Lintott</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pam Lintott, Nicky Lintott
      </h2>
      
      <p class="authorDescription body article">Pam Lintott is the co-author of <I>Jelly Roll Quilts</I> and the owner of The Quilt Room, Europe's premiere quilting and patchwork shop. Together with her daughter Nicky, Pam has also written <I>Layer Cake, Jelly Roll and Charm Quilts</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David and Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53cdd78e